import type { UseFetchOptions } from 'nuxt/app'
export function useAPI<T>(
  url: string | (() => string),
  options: Omit<UseFetchOptions<T>, 'default'> & { default?: () => T | Ref<T> } = {}
) {
  return useFetch('/api' + url, {
    ...options,
    $fetch: useNuxtApp().$api
  })
}

export function useLazyAPI<T>(
  url: string | (() => string),
  options: Omit<UseFetchOptions<T>, 'default'> & { default?: () => T | Ref<T> } = {}
) {
  return useLazyFetch('/api' + url, {
    ...options,
    $fetch: useNuxtApp().$api
  })
}


export function useAPIFetch<T>(
  url: string | (() => string),
  options: any = {}
) {
  const authStore = useAuthStore()
  const nuxtApp = useNuxtApp()

  return $fetch<T>(typeof url === 'function' ? url() : '/api' + url, {
    ...options,
    headers: {
      ...options.headers,
      // Set Authorization header here as a fallback
      Authorization: `Bearer ${authStore.token}`
    },
    onRequest({ request, options }) {
      // Ensure headers object exists
      options.headers = new Headers(options.headers)

      // Set or update Authorization header
      if (authStore.token) {
        options.headers.set('Authorization', `Bearer ${authStore.token}`)
      }
    },
    $fetch: nuxtApp.$api,
  });
}

export function useAPISearch<T>(
  url: string | (() => string),
  options: Omit<UseFetchOptions<T>, 'default'> & { default?: () => T | Ref<T> } = {}
) {
  return useFetch('/api/search' + url, {
    ...options,
  })
}